module.exports = __webpack_public_path__ + "static/empty-states-levels-dont-8331b852fa5fe092b6990517b2c7ec37.png";